// Shared Swedish organisation-number helpers. Mirrors the validation used in
// the onboarding flow so admin-created accounts can't be saved with an invalid
// org number that would then block the user in onboarding.

export function orgDigitsOnly(value: string): string {
  return (value || '').replace(/\D/g, '');
}

/**
 * Validates a Swedish organisation number: exactly 10 digits (dashes/spaces
 * ignored) that pass the Luhn / modulo-10 check.
 */
export function isValidOrgNumber(raw: string): boolean {
  const digits = orgDigitsOnly(raw);
  if (digits.length !== 10) return false;
  let sum = 0;
  for (let i = 0; i < 9; i++) {
    const product = Number(digits[i]) * (i % 2 === 0 ? 2 : 1);
    sum += product > 9 ? product - 9 : product;
  }
  sum += Number(digits[9]);
  return sum % 10 === 0;
}
